<template>
  <section class="location-section">
    <div class="container">
      <div class="location-grid">
        <div class="location-details">
          <h2 class="section-title">Lokasi Emas di Jantung Kawasan Pendidikan</h2>
          <p class="section-subtitle">
            Terletak di Jl. Raya Dramaga, Paradisa Studenté dikelilingi oleh fasilitas penting dan menjadi pusat aktivitas mahasiswa. Dengan target pasar lebih dari <strong>10.000 mahasiswa baru IPB setiap tahun</strong>, investasi Anda memiliki jaminan permintaan yang tinggi.
          </p>
          <ul class="poi-list">
            <li>✔️ Kampus IPB Dramaga</li>
            <li>✔️ Rumah Sakit Medika Dramaga</li>
            <li>✔️ Akses Gerbang Tol Yasmin</li>
            <li>✔️ Pusat Perbelanjaan (Superindo, Botani Mart)</li>
            <li>✔️ Kawasan Wisata Danau Situgede</li>
            <li>✔️ Restoran Cepat Saji (McDonald's)</li>
          </ul>
        </div>
        <div class="location-map">
          <img src="https://firebasestorage.googleapis.com/v0/b/paradisa-project.firebasestorage.app/o/web_assets%2FScreenshot%202025-07-28%20230624.png?alt=media&token=2404bfa5-4325-4b19-b9bd-6f4f88c18e5e" alt="Peta Lokasi Paradisa Studenté">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LocationSection'
}
</script>

<style scoped>
.location-section {
  padding: 80px 0;
  background-color: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.location-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  align-items: center;
}

.section-title {
  font-size: 2.2rem;
  text-align: left;
  margin-bottom: 15px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #555;
  text-align: left;
  line-height: 1.6;
  margin-bottom: 30px;
}

.poi-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.poi-list li {
  font-size: 1.1rem;
  margin-bottom: 15px;
  font-weight: 500;
}

.location-map img {
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

@media (max-width: 992px) {
  .location-grid {
    grid-template-columns: 1fr;
  }
  .section-title, .section-subtitle {
    text-align: center;
  }
  .location-details {
    order: 2; /* Pindahkan teks ke bawah gambar di mobile */
  }
  .location-map {
    order: 1;
  }
   .poi-list {
    columns: 2; /* Buat list menjadi 2 kolom di mobile */
  }
}
</style>